import { Avatar, Button, ChatContainer, ConversationHeader, MainContainer, Message, MessageInput, MessageList, TypingIndicator } from "@chatscope/chat-ui-kit-react";
import "@chatscope/chat-ui-kit-styles/dist/default/styles.min.css";
import FingerprintJS from "@fingerprintjs/fingerprintjs";
import axios from "axios";
import { MessageCircle, X } from "lucide-react";
import { useEffect, useState } from "react";
import "./style.css";

const LiveChat = () => {
  const [userId, setUserId] = useState("");
  const [messages, setMessages] = useState([{ message: "Hello! How can I assist you today?", sender: "AI Support", direction: "incoming" }]);
  const [typing, setTyping] = useState(false);
  const [chatOpen, setChatOpen] = useState(false);
  const [animatedMessage, setAnimatedMessage] = useState("");

  let messageListRef = null;

  const typeText = (text, callback) => {
    let i = 0;
    setAnimatedMessage("");

    const interval = setInterval(() => {
      if (i < text.split(" ").length) {
        setAnimatedMessage((prev) => prev + " " + text.split(" ").at(i));
        i++;
      } else {
        clearInterval(interval);
        callback();
      }
    }, 60);
  };

  useEffect(() => {
    const generateUserId = async () => {
      const storedId = localStorage.getItem("userId");
      if (storedId) {
        setUserId(storedId);
      } else {
        const fp = await FingerprintJS.load();
        const result = await fp.get();
        const newUserId = result.visitorId;
        localStorage.setItem("userId", newUserId);
        setUserId(newUserId);
      }
    };
    generateUserId();
  }, []);

  const sendMessage = async (text) => {
    if (text.trim()) {
      setMessages((prev) => [...prev, { message: text, sender: "User", direction: "outgoing" }]);
      setTyping(true);

      try {
        const response = await axios.post(process.env.REACT_APP_BACKEND_URL + "/api/chat", { userId, content: text });
        const botMessage = response.data.data;

        // Start typing animation
        typeText(botMessage, () => {
          setMessages((prev) => [...prev, { message: botMessage, sender: "AI Support", direction: "incoming" }]);
          setAnimatedMessage("");
          setTyping(false);
        });
      } catch (error) {
        const errorMsg = error?.response?.data?.message || "Sorry, something went wrong.";
        typeText(errorMsg, () => {
          setMessages((prev) => [...prev, { message: errorMsg, sender: "AI Support", direction: "incoming" }]);
          setAnimatedMessage("");
          setTyping(false);
        });
      }
    }
  };

  useEffect(() => {
    if (messageListRef) {
      messageListRef.scrollToBottom();
    }
  }, [messages]);

  return (
    <div className="chat-widget" data-open={chatOpen.toString()}>
      {!chatOpen && (
        <button className="chat-toggle-btn" onClick={() => setChatOpen(true)}>
          <MessageCircle size={40} />
        </button>
      )}

      {chatOpen && (
        <div className="chat-box">
          <MainContainer className="chat-main">
            <Button className="close-btn" variant="ghost" onClick={() => setChatOpen(false)}>
              <X size={20} />
            </Button>
            <ChatContainer>
              <ConversationHeader className="chat-header">
                <Avatar src="/assets/gm.jpg" name="AI Support" />
                <ConversationHeader.Content userName="AI Support" info="Online" className="header-content" />
              </ConversationHeader>

              <MessageList ref={(el) => (messageListRef = el)} className="message-list" typingIndicator={typing ? <TypingIndicator content="AI Support is typing..." /> : null}>
                {messages.map((msg, index) => (
                  <Message key={index} model={{ message: msg.message, sender: msg.sender, direction: msg.direction }} />
                ))}

                {/* Append animated message if it exists */}
                {animatedMessage && (
                  <Message
                    model={{
                      message: animatedMessage,
                      sender: "AI Support",
                      direction: "incoming",
                    }}
                  />
                )}
              </MessageList>

              <MessageInput placeholder="Type a message..." className="chat-input" onSend={sendMessage} sendButton={true} attachButton={false}/>
            </ChatContainer>
          </MainContainer>
        </div>
      )}
    </div>
  );
};

export default LiveChat;
